import { useEffect } from 'react';

/**
 * Minimal per-route document head management — no react-helmet dependency needed for
 * an app this size. Sets <title> and the meta description; the canonical/OG tags in
 * index.html cover the root route well enough for a single-location local business.
 */
export function useDocumentMeta(title: string, description?: string): void {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let descTag: HTMLMetaElement | null = null;
    let prevDesc: string | null = null;
    if (description) {
      descTag = document.querySelector('meta[name="description"]');
      if (descTag) {
        prevDesc = descTag.getAttribute('content');
        descTag.setAttribute('content', description);
      }
    }

    return () => {
      document.title = prevTitle;
      if (descTag && prevDesc !== null) descTag.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}
